<template>
  <ul :id="[has_children ? parent.slug : '#categories']" class="fs-5 p-0" :class="[has_children ? 'collapse show' : '']">
    <span v-for="(item, index) in model" :key="index">
      <a class="widget-link" :class="[item.children != null ? 'bold' : '']">
        <a v-if="item.type == 'folder'" :href="'#' + item.slug" :data-bs-toggle="[item.children == null ? '' : 'collapse']" class="folder-class" @click="selectItem(item)">
          <i class="text-secondary fas fa-caret-down fs-4"></i>
          <span class="text-secondary fs-5">
            {{ item.text }}
          </span>
        </a>
        <span v-if="item.type != 'folder'" :class="item.type == 'root' ? 'text-primary fs-4' : ''" style="line-break: anywhere;" @click="selectItem(item)">
          <i v-if="item.type == 'root'" class="fas fa-caret-down text-primary fs-3"></i>
          <span>
            <span v-if="item.type == 'root'">&nbsp;{{ item.text }}</span>
            <span v-else class="selected-node" :class="selectedItem == item ? 'text-primary' : 'text-secondary'">&nbsp;{{ item.text }}</span>
            <i v-if="item.type == 'root' && !isExpanded && hasFolders" :title="$t('expand-all')" class="fas fa-up-right-and-down-left-from-center text-primary fs-5 ms-2" @click="expandAll"></i>
            <i v-if="item.type == 'root' && isExpanded && hasFolders" :title="$t('collapse-all')" class="fa-solid fa-down-left-and-up-right-to-center text-primary fs-5 ms-2" @click="collapseAll"></i>
          </span>
        </span>
        <TreeItem v-if="item.children != null" :bus="bus" :has_children="true" :model="item.children" :parent="item"></TreeItem>
      </a>
    </span>
  </ul>
</template>
<script>
export default {
  name: 'TreeItem', // necessary for self-reference
  props: {
    model: {
      type: Array,
      default: null,
    },
    has_children: {
      type: Boolean,
      default: false,
    },
    parent: {
      type: Object,
      default: null,
    },
    bus: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedItem: null,
      isExpanded: false,
      hasFolders: true,
    };
  },
  computed: {
    isFolder() {
      return this.model.children && this.model.children.length;
    },
  },
  created() {
    this.bus.$on('root-node-selected', () => {
      if (this.model[0] && this.model[0].type == 'root') {
        this.selectItem(this.model[0]);
      }
    });
  },
  mounted() {
    this.bus.$on('selected-node', node => {
      this.selectItem(node);
    });
    const folders = document.querySelectorAll('.folder-class');
    if (folders.length == 0) {
      this.hasFolders = false;
      return;
    }
  },
  methods: {
    changeType() {
      if (!this.isFolder) {
        this.model.children = [];
      }
    },
    selectItem(node) {
      this.selectedItem = node;
      const selectedNodes = document.querySelectorAll('.selected-node.text-primary');
      selectedNodes.forEach(node => {
        if (node != this.selectedItem) {
          node.classList.remove('text-primary');
          node.classList.add('text-secondary');
        }
      });
      this.bus.$emit('node-selected', node);
    },
    toTitleCase(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    expandAll() {
      this.isExpanded = true;
      const collapsedFolders = document.querySelectorAll('.folder-class.collapsed');
      collapsedFolders.forEach(folder => {
        folder.classList.remove('collapsed');
        folder.setAttribute('aria-expanded', 'true');
      });
      const collapsedUls = document.querySelectorAll('ul.collapse');
      collapsedUls.forEach(ul => {
        if (this.model[0] && ul.id === this.model[0].slug) {
          return;
        }
        ul.classList.add('show');
      });
    },
    collapseAll() {
      this.isExpanded = false;
      const expandedFolders = document.querySelectorAll('.folder-class:not(.collapsed)');
      expandedFolders.forEach(folder => {
        folder.classList.add('collapsed');
        folder.setAttribute('aria-expanded', 'false');
      });

      const expandedUls = document.querySelectorAll('ul.collapse.show');
      expandedUls.forEach(ul => {
        if (this.model[0] && ul.id === this.model[0].slug) {
          return;
        }
        ul.classList.remove('show');
      });
    }
  },
};
</script>
<style>
  .widget-link:hover, .widget-link a:hover {
    text-decoration: none;
  }
</style>
